import { useState } from 'react';

const useCustomHook = () => {
  const [valueTab, setValueTab] = useState('list');
  const [loading, setLoading] = useState(true);
  const [comparativeAccountList, setComparativeAccountList] = useState({
    list: [],
    selectedList: [],
  });
  const [openSnack, setOpenSnack] = useState(false);
  const [loadBtn, setLoadBtn] = useState(false);
  const [mainData, setMainData] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [blockAccounts, setBlockAccounts] = useState([]);
  const [accountDetails, setAccountDetails] = useState({
    wallets: [],
    blocks: [],
    guilds: [],
  });
  const [totalCount, setTotoalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [enteredCaptcha, setEnteredCaptcha] = useState('');
  const [captchaId, setCaptchaId] = useState(null);
  const [captchaImg, setCaptchaImg] = useState(null);
  const [captchaLoop, setCaptchaLoop] = useState();
  const [isDisable, setDisable] = useState({
    isPayaDisable: false,
    isCardDisable: false,
    isSatnaDisable: true,
  });
  const [list, setList] = useState({ card: [], sheba: [] });
  const [cardInfoAcc, setCardInfoAcc] = useState('SETTLEMENT_TOOL_PAYA');
  const [show, setShow] = useState(true);
  const [selectedValue, setSelectedValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [saveNumber, setSaveNumber] = useState(false);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [role, setRole] = useState();
  const [itemNeed, setItemNeed] = useState([]);
  const [blockedAccounts, setBlockedAccounts] = useState([]);
  const [inquiryAccount, setInquiryAccount] = useState('');
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [totalItems, setTotalItems] = useState([]);
  const [totalItemsorigin, setTotalItemsorigin] = useState([]);
  const [isDisableAll, setIsDisableAll] = useState(false);
  const [loadingAccounts, setLoadingAccount] = useState(false);
  const [firstAccount, setFirstAccount] = useState(null);
  //========== دیالوگ پرداخت موفق کارتابل ================================
  const [isOpenCartableMessageDg, setIsOpenCartableMessageDg] = useState(false);
  const [requestId, setRequestId] = useState(null);
  //=======================================================================
  return {
    enteredCaptcha, setEnteredCaptcha,
    openDialog,
    setOpenDialog,
    totalItems,
    setTotalItems,
    loadingAccounts,
    setLoadingAccount,
    isLoading,
    setIsLoading,
    isLoadingBtn,
    setIsLoadingBtn,
    mainData, setMainData,
    captchaId,
    setCaptchaId,
    role,
    setRole,
    captchaImg,
    setCaptchaImg,
    itemNeed,
    setItemNeed,
    itemNeed,
    setItemNeed,
    setSaveNumber,
    blockedAccounts,
    setBlockedAccounts,
    inquiryAccount,
    setInquiryAccount,
    saveNumber,
    setSaveNumber,
    captchaLoop,
    setCaptchaLoop,
    isDisable,
    setDisable,
    list,
    setList,
    openSnack,
    setOpenSnack,
    cardInfoAcc,
    setCardInfoAcc,
    show,
    setShow,
    selectedValue,
    setSelectedValue,
    openBackDrop,
    setOpenBackDrop,
    blockAccounts,
    setBlockAccounts,
    accountDetails,
    setAccountDetails,
    totalCount,
    setTotoalCount,
    currentPage,
    setCurrentPage,
    loading,
    setLoading,
    valueTab,
    setValueTab,
    comparativeAccountList,
    setComparativeAccountList,
    totalItemsorigin, setTotalItemsorigin,
    loadBtn,
    setLoadBtn,
    isDisableAll,
    setIsDisableAll,
    firstAccount, setFirstAccount,
    isOpenCartableMessageDg, setIsOpenCartableMessageDg,
    requestId, setRequestId,
  };
};

export default useCustomHook;
